import { Button, Container, Form, Stack } from "react-bootstrap";
import "./css/style.css";
import { useAppContext } from "../../route/Context";
import { exitUser , ListAll } from "../../axios";
import { useEffect, useState } from "react";
import AdminCart from "./cart";
import FormAdd from "./form";

export default function Panel() {
    const [load, setLoad] = useState(false);
    const [list, setList] = useState([]);
    const [wiretapping, setWiretapping] = useState(false);
    const [formAdd, setFormAdd] = useState(false);
    const [redactId, setredactId] = useState({});
    const [filterStatus, setFilterStatus] = useState('all'); // Для фильтрации по статусу

    const { isAuthenticated, setIsAuthenticated } = useAppContext();

    function exitSistem() {
        exitUser ();
        setIsAuthenticated(false);
    }

    const handleLoadList = async () => {
        const rezult = await ListAll();
        if (rezult.success) {
            setList(rezult.list);
            setLoad(true);
        } else {
            setLoad(false);
        }
    };

    const taskRedact = (e) => {
        setFormAdd(!formAdd);
        setredactId(e);
    };

    useEffect(() => {
        handleLoadList();
    }, []);

    useEffect(() => {
        handleLoadList();
    }, [wiretapping]);

    const filteredList = () => {
        if (filterStatus === 'active') {
            return list.filter(e => e.status === '1');
        } else if (filterStatus === 'hidden') {
            return list.filter(e => e.status === '0');
        }
        return list; // 'all' case
    };

    return (
        <>
            <header className="header-p">
                <Container className="flex">
                    <a href="/"><img className="logo" src="/logotmp.svg" alt="" /></a>
                    <Button onClick={exitSistem} variant="success" className="bek">
                        Выйти
                    </Button>
                </Container>
            </header>
            <main>
                <Container>
                    <Stack direction="horizontal" className="mt-5" gap={2}>
                        <div className="listAd-infoBox">
                            <Form.Group>
                                <div className="btn-group">
                                    <Button
                                        variant={filterStatus === 'all' ? 'primary' : 'secondary'}
                                        onClick={() => setFilterStatus('all')}
                                    >
                                       {list !== null && `Все объекты: ${list.length}`}
                                    </Button>
                                    <Button
                                        variant={filterStatus === 'active' ? 'primary' : 'secondary'}
                                        onClick={() => setFilterStatus('active')}
                                    >
                                       {list !== null && `Активные: ${list.filter(e=>e.status==1).length}`}
                                    </Button>
                                    <Button
                                        variant={filterStatus === 'hidden' ? 'primary' : 'secondary'}
                                        onClick={() => setFilterStatus('hidden')}
                                    >
                                        {list !== null && `Скрытые: ${list.filter(e=>e.status==0).length}`}
                                    </Button>
                                </div>
                            </Form.Group>
                        </div>
                        <Button className="bek" variant="success" onClick={() => setFormAdd(true)}>
                            +Добавить
                        </Button>
                    </Stack>
                    <div className="site_grid mb-5 mt-5">
                        {filteredList().map((e) => (
                            <AdminCart key={e.id} item={e} setWiretapping={() => setWiretapping(!wiretapping)} taskRedact={taskRedact} />
                        ))}
                    </div>
                </Container>
                <FormAdd
                    show={formAdd}
                    onHide={() => { setFormAdd(false); setredactId({}) }}
                    setWiretapping={() => setWiretapping(!wiretapping)}
                    element={redactId}
                />
            </main>
        </>
    );
}
